import * as Yup from 'yup';
import { DictCountry } from '@models';

export function useValidationSchema() {
  return Yup.object<DictCountry>().shape({
    code: Yup.string().nullable().required(),
    name: Yup.string().nullable().required(),
  });
}
